import { render } from "./DeleteProjectModal.vue?vue&type=template&id=73a96db9&scoped=true&ts=true"
import script from "./DeleteProjectModal.vue?vue&type=script&lang=ts"
export * from "./DeleteProjectModal.vue?vue&type=script&lang=ts"

import "./DeleteProjectModal.vue?vue&type=style&index=0&id=73a96db9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a96db9"]])

export default __exports__